//REF-> https://dev.to/damianof/typescript-wrapping-axios-with-an-httpclient-class-o7f
var HttpClient = /** @class */ (function () {
    function HttpClient() {
    }
    HttpClient.prototype.setActivateClient = function (client) {
        this.clientProvider = client;
    };
    HttpClient.prototype.getActivateClient = function () {
        return this.clientProvider;
    };
    return HttpClient;
}());
export { HttpClient };
//# sourceMappingURL=HttpClient.js.map